"use client";

import { useEffect } from "react";
import { trackPageNotFound } from "@/utils/trackingScripts";

export function NotFoundTracker() {
  useEffect(() => {
    trackPageNotFound();
  }, []);

  return null;
}
